import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoTzm: CultureInfo = {
  name: 'tzm',
  displayName: 'Central Atlas Tamazight',
  iso3LanguageCode: 'tzm',
  iso2LanguageCode: 'tzm',
  ietfLanguageTag: 'tzm',
  parent: null
};
